export default "__VITE_ASSET__DuK57w_b__"